import { render, staticRenderFns } from "./FlavourPicker.vue?vue&type=template&id=298e5e63&"
import script from "./FlavourPicker.vue?vue&type=script&lang=js&"
export * from "./FlavourPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports